/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react'
import {arrayToCombo, optionsStatoNews} from '../../Helpers'

class StatoNewsComboFilter extends Component {
    constructor(props) {
        super(props);
        let fields = {statoNews: props.statoNews}
        this.state = {
            fields: fields,
            dropdownLoading: false,
            dropdownList: [],
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.comboScelte = this.comboScelte.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.statoNews !== this.state.fields.statoNews)
        {
            let fields = this.state.fields;
            fields.statoNews = nextProps.statoNews;
            this.setState({fields},
                ()=>{
                    if ( this.state.fields.statoNews !== undefined){
                        this.props.onChange(
                            this.state.fields.statoNews,
                            this.getDDText(this.state.fields.statoNews, this.state.dropdownList)
                        );
                    }
                });
        }
    }

    componentDidMount(){
        this.comboScelte();
    }

    getDDText(value, options){
        let selectedItem = options.find((it) => {
            return it.value === value;
        })
        return selectedItem ? selectedItem.text : '';
    }

    comboScelte(){  
        let items = [];
        items = items.concat(optionsStatoNews.map(value => {return  {statoNews: value.key, nome: value.text}}));
        this.setState(
            {
                dropdownLoading: false,
                error: null,
                dropdownList: arrayToCombo(items, "statoNews", "nome", "statoNews", false)
            },
            ()=>{
            if ( this.state.fields.statoNews !== undefined){
                this.props.onChange(
                    this.state.fields.statoNews,
                    this.getDDText(this.state.fields.statoNews, this.state.dropdownList)
                );
            }
        })
    }

    onInputChange(a1, b1) {
        let name = b1.name;
        let value = b1.value;

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields }, () => {
                this.props.onChange(this.state.fields.statoNews, this.getDDText(value, b1.options));
            });

        }
    }

    render() {
        return (
            <div className="ui form">
                    <Form.Field className="fields">
                        <Form.Dropdown width={16} style={{width:"100%"}} placeholder="Stato" name='statoNews' disabled={this.props.abilitato === false} loading={this.state.dropdownLoading} search selection options={this.state.dropdownList} value={this.state.fields.statoNews} onChange={this.onInputChange}/>
                    </Form.Field>
            </div>)
    }
}

StatoNewsComboFilter.PropTypes = {
    statoNews: PropTypes.string.isRequired, 
    abilitato: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

StatoNewsComboFilter.defaultProps = {
    statoNews: '0',
    abilitato: false
};
export default StatoNewsComboFilter;



/** WEBPACK FOOTER **
 ** ./src/components/news/StatoNewsComboFilter.js
 **/